import React, { useState, useEffect } from "react";
// import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import "./datetimefilter.scss";
// import { ReactComponent as Filtericon } from "../../../assets/icons/filtericon.svg";
import "../../containers/RefillManagement-CRUD/refillmanagement_crud.scss";
import { Divider } from "@material-ui/core";
import CustomButton from "../../components/Button";
// import CustomInput from "../Input";
import CustomDateAndTimePicker from "../DateAndTimePicker";

import DownArrow from "../../../assets/icons/arrow.svg";
import UpArrow from "../../../assets/icons/up-arrow.svg";
import { preventDefaultBehaviour } from "services/commonMethods";
// import DownArrow from "../../../assets/icons/CaretDown.svg";
// import UpArrow from "../../../assets/icons/CaretUp.svg";
function DateAndTimeFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  // const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  //State Management.
  const initialFilter = {
    reset: true,
    all: false,
    created: false,
    accepted: false,
    declined: false,
    deleted_by_rp: false,
    deleted_by_vmo: false,
    picked_up: false,
    executed: false,
  };
  const [selected, setSelected] = useState(initialFilter);

  const open = Boolean(anchorEl);

  const handleClose = (timeGap) => {
    setAnchorEl(null);
    props.handleDateTime(dateFrom, dateTo);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const getRefillStateColor = (state) => {
  //   switch (state) {
  //     case 1:
  //       return "#44D6F6";
  //     case 2:
  //       return "#3AB2CC";
  //     case 3:
  //       return "#4CB04E";
  //     case 4:
  //       return "#4B6E86";
  //     case 5:
  //       return "#F95A3F";
  //     case 7:
  //       return "#83B40B";
  //     default:
  //       return;
  //   }
  // };

  // const filterChangeHandler = (ev) => {
  //   if (ev.target.name === "all" && !ev.target.checked) {
  //     setSelected(initialFilter);
  //   } else {
  //     setSelected({ ...selected, [ev.target.name]: ev.target.checked });
  //   }
  // };

  useEffect(() => {
    setDateFrom(props.dateFrom);
    setDateTo(props.dateTo);
  }, [props.dateFrom, props.dateTo]);

  return (
    <div className="transactions-filter">
      <CustomButton
        style={{ width: "130px" }}
        onClick={handleClick}
        type="button"
        btnProps={{
          text: [
            "Date",
            <img
              src={open ? UpArrow : DownArrow}
              style={{ marginLeft: "50px" }}
              className={"add-icon"}
              alt="Add-btn Icon Image"
              key={0}
            />,
          ],
          className: "filter-date",
          variant: "outlined",
          // onclick: handleClick,
        }}
      />
      <Menu
        className="transactions-filter__menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <CustomDateAndTimePicker
            formControlProps={{
              fullWidth: true,
              margin: "normal",
              className: "add-screen-formcontrol",
              style: {
                width: "94%",
              },
            }}
            dateAndTimePickerProps={{
              value: dateFrom,
              onChange: (dateTime) => setDateFrom(dateTime),
              label: "Start Date & Time",

              name: "start_date",
              className: "input-add-date-screen",
              // open: true,
              variant: "outlined",
              shrink: true,
              maxDate: new Date().getInputDateTimeFormat(),
              minDateMessage: "",
              onKeyPress: preventDefaultBehaviour,
              ampm: true,
              inputVariant: "outlined",
              format: "dd/MM/yyyy hh:mm a",
              id: "product-expiry-date",
              KeyboardButtonProps: {
                "aria-label": "With keyboard",
              },
              autoOk: true,
            }}
          />
        </MenuItem>
        <span style={{ marginLeft: "120px" }}>To</span>
        <MenuItem>
          <CustomDateAndTimePicker
            formControlProps={{
              fullWidth: true,
              margin: "normal",
              className: "add-screen-formcontrol",
              style: {
                width: "94%",
              },
            }}
            dateAndTimePickerProps={{
              value: dateTo,
              onChange: (dateTime) => setDateTo(dateTime),
              label: "End Date & Time",
              // required: true,
              name: "start_date",
              className: "input-add-date-screen",
              // open: true,
              variant: "outlined",
              shrink: true,
              maxDate: new Date().getInputDateTimeFormat(),
              minDateMessage: "",
              onKeyPress: preventDefaultBehaviour,
              ampm: true,
              inputVariant: "outlined",
              format: "dd/MM/yyyy hh:mm a",
              id: "product-expiry-date",
              KeyboardButtonProps: {
                "aria-label": "With keyboard",
              },
              autoOk: true,
              PopoverProps: {
                anchorOrigin: { horizontal: "center", vertical: "bottom" },
                transformOrigin: { horizontal: "center", vertical: "bottom" },
              },
            }}
          />
        </MenuItem>
        <Divider />
        <MenuItem></MenuItem>
        <Divider />
        {/* <CustomButton
          type="button"
          color="primary"
          btnProps={{
            variant: "contained",
            className: "add-btn ml-5 mt-2",
            text: ["Cancel"],

            onClick: () => {
              handleClose();
            },
          }}
        />
        <CustomButton
          type="button"
          btnProps={{
            variant: "contained",
            className: "add-btn ml-5 mt-2",

            color: "success",
            text: ["Apply"],

            onClick: () => {
              props.refillFilterHandler(selected);
              handleClose();
            },
          }}
        /> */}
      </Menu>
    </div>
  );
}

export default DateAndTimeFilter;
